/* assets/mm-layer-explainer.js — <mm-layer-explainer>: Frucht-Stops der Grafik + Frucht-Zeile folgen dem Sortenschalter (mm:flavor-change) */
(function () {
  'use strict';
  if (!('customElements' in window) || customElements.get('mm-layer-explainer')) return;
  class MMLayerExplainer extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute('data-follow-flavor')) return;
      this._onFlavor = this._onFlavor.bind(this);
      document.addEventListener('mm:flavor-change', this._onFlavor);
      var root = document.documentElement.style;
      var fruit = getComputedStyle(document.documentElement).getPropertyValue('--mm-fruit').trim();
      if (fruit) this._apply({ colors: { fruit: fruit, light: getComputedStyle(document.documentElement).getPropertyValue('--mm-fruit-light').trim(), dark: getComputedStyle(document.documentElement).getPropertyValue('--mm-fruit-dark').trim() } });
      void root;
    }
    disconnectedCallback() { if (this._onFlavor) document.removeEventListener('mm:flavor-change', this._onFlavor); }
    _onFlavor(evt) { this._apply(evt.detail || {}); }
    _apply(d) {
      var c = d.colors || {}; if (!c.fruit) return;
      var stops = this.querySelectorAll('[data-mm-layer-swirl] linearGradient stop'); var n = stops.length;
      if (n >= 3) {
        if (c.light) stops[n - 3].setAttribute('stop-color', c.light);
        stops[n - 2].setAttribute('stop-color', c.fruit);
        stops[n - 1].setAttribute('stop-color', c.dark || c.fruit);
      }
      var row = this.querySelector('[data-mm-fruit-row]');
      if (row) {
        row.style.setProperty('--mm-circle', c.dark || c.fruit);
        var t = row.querySelector('[data-mm-fruit-title]'), x = row.querySelector('[data-mm-fruit-text]');
        if (t && d.layerTitle) t.textContent = d.layerTitle;
        if (x && d.layerText) x.textContent = d.layerText;
      }
    }
  }
  customElements.define('mm-layer-explainer', MMLayerExplainer);
})();
